import { Box } from "@mui/material";
import React from "react";
import Navbar from "../../components/shared/Navbar";
import ArchivedStudentList from "../../components/Student/ArchivedStudentList";

export default function StudentInformationArchived() {
  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#F4F7FB" }}>
      {" "}
      <Navbar pageTags={["Home", "Student Information", "Archived"]} />
      <Box sx={{ my: "50px" }}>
        <ArchivedStudentList />
      </Box>
    </Box>
  );
}
